// The react-base screens' icons under the names they had in lucide-react,
// drawn with our Phosphor set (components/oktober/brand.tsx), so the whole app
// shares one icon style. Size them with classes (h-4 w-4, size-4) as before.

import type { CSSProperties } from 'react';
import { Icon } from '@/components/oktober/brand';
import type { IconName, IconWeight } from '@/components/oktober/brand';

type Props = { className?: string; style?: CSSProperties; size?: number | string; strokeWidth?: number; 'aria-hidden'?: boolean | 'true' | 'false' };

function make(name: IconName, weight: IconWeight = 'regular') {
  const Component = ({ className, style, size }: Props) => (
    <Icon name={name} weight={weight} size={typeof size === 'number' ? size : 24} className={className} style={style} />
  );
  Component.displayName = name;
  return Component;
}

export const AlertTriangle = make('warning');
export const TriangleAlertIcon = AlertTriangle;
export const ArrowDown = make('arrow-down');
export const ArrowUp = make('arrow-up');
export const ArrowLeft = make('arrow-left');
export const ArrowUpDown = make('arrows-up-down');
export const Bold = make('bold');
export const Check = make('check');
export const CheckIcon = Check;
export const CheckCircle = make('check-circle');
export const CheckCircle2 = CheckCircle;
export const CircleCheckIcon = CheckCircle;
export const ChevronDown = make('chevron-down');
export const ChevronDownIcon = ChevronDown;
export const ChevronUpIcon = make('chevron-up');
export const ChevronLeft = make('chevron-left');
export const ChevronRight = make('chevron-right');
export const ChevronRightIcon = ChevronRight;
export const ChevronsLeft = make('chevrons-left');
export const ChevronsRight = make('chevrons-right');
export const CircleIcon = make('circle', 'fill');
export const Copy = make('copy');
export const Eye = make('eye');
export const EyeOff = make('eye-off');
export const FileText = make('doc');
export const Filter = make('filter');
export const Hash = make('hash');
export const Heading2 = make('heading');
export const History = make('history');
export const Home = make('home');
export const InfoIcon = make('info');
export const Italic = make('italic');
export const KeyRound = make('key');
export const Languages = make('languages');
export const List = make('list');
export const ListOrdered = make('list-ordered');
export const Loader2 = make('spinner');
export const Loader2Icon = Loader2;
export const Mail = make('mail');
export const MailPlus = make('mail-open');
export const Minus = make('minus');
export const Monitor = make('monitor');
export const Moon = make('moon');
export const MoreHorizontal = make('more');
export const OctagonXIcon = make('x-circle');
export const Pencil = make('pencil');
export const Pilcrow = make('paragraph');
export const Plus = make('plus');
export const Quote = make('quote');
export const RefreshCw = make('refresh');
export const RotateCcw = make('rotate-ccw');
export const Search = make('search');
export const Settings = make('settings');
export const Shield = make('shield');
export const ShieldOff = make('shield-off');
export const Strikethrough = make('strikethrough');
export const Sun = make('sun');
export const Trash2 = make('trash');
export const Underline = make('underline');
export const UserCheck = make('user-check');
export const UserCircle = make('user-circle');
export const UserX = make('user-minus');
export const Users = make('users');
export const X = make('x');
export const XIcon = X;
export const XCircle = make('x-circle');
